import './phone-script-redirection-actions.ajscss';

import { AgentDesktopRouter } from '@agent/agent-interface/agent-desktop-router';
import { IScriptRedirect } from '@agent/core/phone/script-redirection/models/script-redirection';
import { IScriptRedirectionService } from '@agent/core/phone/script-redirection/script-redirection.service';
import { IComponentController, IComponentOptions } from 'angular';

import { DisplayDeprecatedComponent } from '@contact/upgrade';

import templateUrl from './phone-script-redirection-actions.template.html';

export class PhoneScriptRedirectionActionsCtrl extends DisplayDeprecatedComponent implements IComponentController {
  responseId: string;

  constructor(protected readonly scriptRedirectionService: IScriptRedirectionService, protected readonly router: AgentDesktopRouter) {
    super();
  }

  get scriptRedirect(): IScriptRedirect {
    return this.scriptRedirectionService
      .getScriptRedirect(this.responseId)
      .getOrElseFunc(() => this.scriptRedirectionService.createScriptRedirect(this.responseId));
  }

  get canValidateScriptRedirect(): boolean {
    return (
      this.scriptRedirectionService.canValidateScriptRedirect(this.responseId) &&
      !!this.scriptRedirect.target &&
      this.scriptRedirect.target.type === this.scriptRedirect.type
    );
  }

  $onInit() {}

  validateScriptRedirection(): void {
    if (this.canValidateScriptRedirect) {
      this.scriptRedirectionService.executeScriptRedirection(this.responseId);
    }
  }

  cancelScriptRedirection(): void {
    this.router.navigateFromLastChild(['..']);
  }

  unparkContactAndAgent(): void {
    this.scriptRedirectionService.unparkContactAndAgent(this.responseId).then(() => {
      this.router.navigateFromLastChild(['..']);
    });
  }
}

export class PhoneScriptRedirectionActions implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    responseId: '<',
  };
  controller = ['scriptRedirection', 'agentDesktopRouter', PhoneScriptRedirectionActionsCtrl];
}

export default 'contactPhoneScriptRedirectionActions';
